<template>
  <v-container class="px-5 col-12">
    <div class="v-card--material__header d-flex align-center v-card v-sheet elevation-10 teal mr-10 ml-7 mt-3 mb-5" style="min-height: 55px;">
      <v-simple-table class="pa-0 col-12 account-short-info">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">Name</th>
            <th class="text-left">Host</th>
            <th class="text-left">Balance</th>

            <th class="text-left">Login</th>
            <th class="text-left">Balance</th>

            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ entity.entity_id }}</td>
            <td>{{ entity.name }}</td>
            <td>{{ entity.host }}</td>
            <td>
              <template v-for="balance in entity.wallet">
                {{ balance.currency }} <b class="mr-2">{{ balance.balance }}</b>
              </template>
            </td>


            <td style="border-left: 1px solid #4CAF50">
              <a :href="'/user-management/' + account.login " target="_blank">{{ account.login }}</a>
            </td>
            <td>{{ account.currency }} <b class="mr-2">{{ account.balance }}</b></td>

            <td>
              <account-search :entity_id="entity.entity_id" />
              <v-btn color="info" @click="refresh()" dark icon :loading="refreshing">
                <v-icon>refresh</v-icon>
              </v-btn>
            </td>
          </tr>
          </tbody>

        </template>
      </v-simple-table>
    </div>

    <v-tabs
      background-color="white"
      color="teal"
      v-model="tab"
      right
    >
      <v-tab>General</v-tab>
      <v-tab>Finance</v-tab>
    </v-tabs>
    <v-divider />

    <v-tabs-items touchless v-model="tab">
      <v-tab-item>
        <v-row class="mx-0">
          <v-col id="sport_frame" ref="sport_frame" class="col-8 mx-0 pl-0 overflow-y-auto" :style="`height: calc(100vh - 205px - ${!$store.state.auth.default_user ? '0px' : '24px'})`">
            <div class="altenar"></div>
            <v-skeleton-loader
              v-if="sportLoader"
              class="mx-4"
              height="500"
              type="card"
            ></v-skeleton-loader>
          </v-col>
          <v-col class="col-4 pl-0 mx-0 overflow-y-auto" :style="`height: calc(100vh - 205px - ${!$store.state.auth.default_user ? '0px' : '24px'})`">

            <v-row class="mx-0">
              <v-select
                :items="dateRangeList"
                :value="dateRangeList[0]"
                label="Period"
                hide-details
                @change="changeTimePeriod"
                class="px-2"
              />

              <v-btn
                color="info"
                class="mt-3 ml-3"
                @click="search"
              >
                Search
              </v-btn>
            </v-row>
            <v-row class="mx-0 mt-2">
              <date-picker
                v-model="sportHistory.from"
                label="Date From"
                style="max-width: 240px"
                :show-time="true"
                :time-value="sportHistory.fromTime"
                @time-change="sportHistory.fromTime = $event"
              />
              <date-picker
                v-model="sportHistory.to"
                label="Date To"
                style="max-width: 240px"
                :show-time="true"
                :time-value="sportHistory.toTime"
                @time-change="sportHistory.toTime = $event"
              />
            </v-row>

            <v-divider />

            <template>
              <v-container fluid class="px-0">
                <v-data-iterator
                  :items="sportHistory.items"
                  :items-per-page="-1"
                  :search="sportHistory.search"
                  hide-default-footer
                >
                  <template v-slot:header>
                    <v-toolbar
                      dark
                      color="teal darken-3"
                      class="mb-1"
                    >
                      <v-text-field
                        v-model="sportHistory.search"
                        clearable
                        flat
                        solo-inverted
                        hide-details
                        prepend-inner-icon="search"
                        label="Search"
                      ></v-text-field>
                    </v-toolbar>
                  </template>

                  <template v-slot:default="props">
                    <v-row>
                      <v-col
                        v-for="item in props.items"
                        :key="item.round_id"
                        cols="12"
                      >
                        <v-card :id="'betslip-' + item.round_id">
                          <v-card-title class="subheading font-weight-bold">
                            ID: {{ item.round_id }}
                            <v-spacer />
                            <v-btn color="teal" @click="print('betslip-' + item.round_id)" dark icon>
                              <v-icon>print</v-icon>
                            </v-btn>
                          </v-card-title>

                          <v-divider></v-divider>

                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content class="col-3">Status:</v-list-item-content>
                              <v-list-item-content class="col-9 align-end">{{ item.status }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content class="col-3">Date:</v-list-item-content>
                              <v-list-item-content class="col-9 align-end">{{ item.created }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="item.finalized">
                              <v-list-item-content class="col-3">Finalized:</v-list-item-content>
                              <v-list-item-content class="col-9 align-end">{{ item.finalized }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="item.debit">
                              <v-list-item-content class="col-3">Bet:</v-list-item-content>
                              <v-list-item-content class="col-9 align-end">{{ account.currency }} {{ item.debit }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="item.credit">
                              <v-list-item-content class="col-3">Income:</v-list-item-content>
                              <v-list-item-content class="col-9 align-end">{{ account.currency }} {{ item.credit }}</v-list-item-content>
                            </v-list-item>
                            <v-list-item style="padding: auto 6px">
                              <div class="col-12" style="padding: auto 0">
                                <div v-for="r in item.description" class="sport-event-description-item" style="width: 100%; border: 1px solid; padding: 8px 12px; margin-top: -1px;">
                                  <div>
                                    <template v-if="r.category_name">{{ r.category_name }},</template>
                                    <template v-if="r.sport_name">{{ r.sport_name }},</template>
                                    <template v-if="r.tournament_name">{{ r.tournament_name }},</template>
                                    <template v-if="r.market_name">Market: {{ r.market_name }}</template>
                                    <br />
                                    {{ r.competitor_name.join (' - ') }}
                                  </div>
                                  <v-divider style="margin: 2px 0" />
                                  <v-row style="margin: 0">
                                    <div style="">Outcome: {{ r.outcome_name }}</div>
                                    <v-spacer />
                                    <div style="">Odds: {{ r.odds }}</div>
                                  </v-row>
                                </div>
                              </div>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </template>

                </v-data-iterator>
              </v-container>
            </template>

          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <component
          :is="(report.dist || 'default-report')"
          :title="report.name"
          :url="report.url"
          :headers="report.headers"
          :defaultParams="{entity_id: entity.entity_id, ...report.defaultParams}"
          :options="{hideProjectSelector: true, padding: 60, ...report.options}"
          :filters="report.filters || []"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<style>

  .account-header-info > div {
    padding-left: 0;
  }

  .account-header-info table {
    background: transparent;
  }

  .account-short-info th {
    color: #FEFEFE !important
  }

  .account-short-info tbody {
    background: #FEFEFE !important;
    color: rgba(0, 0, 0, 0.87);
  }

  .account-short-info tbody td:first-child {
    border-bottom-left-radius: 4px;
  }

  .account-short-info tbody td:last-child {
    border-bottom-right-radius: 4px;
  }

  .account-short-info,
  .account-short-info.theme--light.v-data-table tbody tr:hover {
    background: none !important;
  }

  .spt-bet-slip {
    margin-right: 65px;
  }

  .betslip-link-container {
    height: calc(100vh - 230px) !important;
  }

  #sport_frame .v-skeleton-loader__image {
    height: calc(100vh - 300px);
  }

</style>

<script>
  import { API } from '@/utils/api'
  import moment from 'moment'
  import { Printd } from 'printd'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    components: {
      AccountSearch: () => import('@/components/kiosk/dashboard/AccountSearch'),
      DefaultReport: () => import('@/components/report/Default'),
      DatePicker
    },

    data: () => ({
      dateRangeList: global.dateRangeList,
      tab: null,
      loading: false,
      refreshing: false,
      bt: null,
      altenarSB: null,
      account: {},
      sportLoader: true,
      entity: {},
      sportHistory: {
        search: '',
        items: [],
        totalRows: [],
        options: {},
        expanded: [],
        loading: false,
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        fromTime: '00:00:00',
        toTime: '23:59:59',
        filters: {
          id: { data: [], type: 'text' },
          parent_id: { data: [], type: 'text' },
          action: { data: [], type: 'select' },
        },
        keys: [
          'created',
          'finalized',
          'round_id',
          'description',
          'debit',
          'credit',
          'status',
        ],
        headers: [
          { text: 'Created', value: 'created' },
          { text: 'Finalized', value: 'finalized' },
          { text: 'RoundID', value: 'round_id', sortable: true, align: 'left' },
          { text: 'Description', value: 'description' },
          { text: 'Debit', value: 'debit' },
          { text: 'Credit', value: 'credit' },
          { text: 'Status', value: 'status' },
          { text: '', value: 'data-table-expand', 'class': 'nowrap' },
        ],
      },
      report: {
        name: 'Money in/out',
        alias: 'money_inout',
        type: 'Financial',
        url: '/$v/reports/money_inout.json',
        options: { accountType: true },
        headers: [
          { text: '#', value: 'row_num', sortable: false },
          { text: 'Created', value: 'created' },
          { text: 'AccountID', value: 'account_id' },
          { text: 'Login', value: 'login' },
          { text: 'Status', value: 'status' },
          { text: 'Currency', value: 'currency' },
          { text: 'Language', value: 'language' },
          { text: 'Country', value: 'country' },
          { text: 'Deposit', value: 'deposit' },
          { text: 'Bonuses', value: 'bonus' },
          { text: 'Release', value: 'release_bonus' },
          { text: 'Withdraw', value: 'withdraw' },
          { text: 'Bonuses Withdraw', value: 'bonus_withdraw' },
          { text: 'FS Deposit', value: 'freespin_deposit' },
          { text: 'FS Withdraw', value: 'freespin_withdraw' },
          { text: 'Withdraw Cancel', value: 'withdraw_cancel' },
          { text: 'Account', value: 'account' },
          { text: 'Paymethod', value: 'paymethod' },
          { text: 'Paysystem', value: 'paysystem' },
          { text: 'Affiliate', value: 'affiliate' },
          { text: 'Platform', value: 'platform' },
        ],
        filters: {
          currency: { data: [], type: 'select' },
          login: { data: [], type: 'text' },
          account_id: { data: [], type: 'text' },
        }
      },

      statusIconMap: {
        pending: 'mdi-pause',
        open: 'mdi-play',
        cashout: 'mdi-account-cash-outline',
        rollback: 'mdi-undo',
        lost: 'mdi-stop',
        won: 'mdi-medal-outline',
      },
      statusColorMap: {
        pending: 'gray',
        open: 'green',
        cashout: 'black',
        rollback: 'red',
        lost: 'red',
        won: 'green',
      }
    }),

    mounted () {
      this.refresh()
      this.launchSport()
    },

    computed: {},

    watch: {},

    methods: {

      print (id) {

        let stylesHtml = ''
        let stylesHrefs = []
        for (const node of [ ...document.querySelectorAll('link[rel="stylesheet"], style') ]) {
          if (!node.getAttribute('href')) {
            stylesHtml += node.innerHTML
          } else {
            stylesHrefs.push(node.getAttribute('href'))
          }
        }

        const d = new Printd()
        d.print(document.getElementById(id), [ stylesHtml, ...stylesHrefs ])

      },
      changeTimePeriod: function (value) {
        this.sportHistory.from = value.from || ''
        this.sportHistory.to = value.to || ''
      },

      search () {
        this.sportHistory.loading = true
        return API.call('/$v/account/sport_history/list.json', {
          login: this.account.login,
          account_id: this.account.account_id,
          from: this.sportHistory.from + ' ' + (this.sportHistory.fromTime || '00:00:00'),
          to: this.sportHistory.to + ' ' + (this.sportHistory.toTime || '23:59:59')
        }, this.account).then(resp => {
          this.sportHistory.items = resp.data
          return resp.data
        }).finally(() => {
          this.sportHistory.loading = false
        })
      },

      refresh () {
        this.refreshing = true
        this.loadEntity().finally(r => {
          this.refreshing = false
        })
        this.loadAccount().finally(r => {
          this.refreshing = false
        })
      },

      launchSport () {
        return API.call('/kiosk/sport/launch.json', {}).then(resp => {
          return new Promise((resolve, reject) => {
            const script = document.createElement('script')
            script.src = resp.data.script
            script.type = 'text/javascript'
            script.onload = () => resolve()
            script.onerror = event => reject(`${event.target.src} failed to load. ¯\\_(ツ)_/¯`)
            // document.body.appendChild(script);
            this.$refs.sport_frame.appendChild(script)
          }).then(r => this[resp.system](resp.data))
        }).catch(e => {
          this.$notification.show = true
          this.$notification.message = e.response.data ? e.response.data.message : e.toString()
          this.$notification.type = 'error'
        }).finally(r => {
          this.loading = false
        })
      },
      loadEntity () {
        this.loading = true

        return API.call('/kiosk/entities/get_base.json', {}).then(resp => {
          this.entity = resp.data
          return resp.data
        }).catch(e => {
        }).finally(r => {
          this.loading = false
        })
      },
      loadAccount () {
        this.loading = true

        return API.call('/kiosk/entities/get_base_account.json', {}).then(resp => {
          this.account = resp.data
          return resp.data
        }).catch(e => {
        }).finally(r => {
          this.loading = false
        })
      },
      betby (data) {
        this.sportLoader = false
        this.bt = new BTRenderer().initialize({
          brand_id: data.brand_id,
          key: data.key,
          // themeName: window.innerWidth < 1450 ? null : 'dourobet',
          lang: 'en',
          target: this.$refs.sport_frame,
          minFrameHeight: 700,
          // betSlipOffsetTop: 0,
          // betslipZIndex: 999,
          onRouteChange: function () {
          },
          onLogin: function () {
          },
          onRegister: function () {
          },
          onSessionRefresh: function () {
          }
        })
      },
      altenar (data) {
        this.sportLoader = false
        this.altenarSB = new AltenarSportsbook('#sport_frame > div.altenar', data)
      },

      destroyIFrame () {
        if (this.bt) {
          return this.bt.kill()
        }

        if (this.altenarSB) {
          return this.altenarSB.destroy()
        }
      }

    },

    beforeDestroy () {
      console.log('destroy')
      this.destroyIFrame()
    }

  }
</script>
